module.exports = __webpack_public_path__ + "img/facebook-icon.f2a06e32.svg";